module.exports = __webpack_public_path__ + "static/media/bed_new_pack_cat_EN_768x290.bd7af63c.png";